import { render, staticRenderFns } from "./ClientAdministrationPdfTemplate.vue?vue&type=template&id=8bc590de&scoped=true&"
import script from "./ClientAdministrationPdfTemplate.vue?vue&type=script&lang=ts&"
export * from "./ClientAdministrationPdfTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./ClientAdministrationPdfTemplate.vue?vue&type=style&index=0&id=8bc590de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc590de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VChip,VIcon,VRow,VSpacer})
